import React from 'react';

import s from './AltSidebar.module.scss';

const AltSidebar = ({ children }) => <div className={s['alt-sidebar']}>{children}</div>;

export default AltSidebar;
